/**
 * Popups simples: qualquer [data-modal-open="X"] abre #modal-X,
 * qualquer [data-modal-close] dentro dele fecha (clique no X, no fundo ou Esc).
 */

const openModal = (modal) => {
  modal.hidden = false;
  document.body.classList.add('modal-open');
  modal.querySelector('input, select, textarea, button')?.focus();
};

const closeModal = (modal) => {
  modal.hidden = true;
  document.body.classList.remove('modal-open');
};

export const initModals = () => {
  const modals = document.querySelectorAll('[id^="modal-"]');
  if (!modals.length) return;

  document.querySelectorAll('[data-modal-open]').forEach((opener) => {
    const modal = document.getElementById(`modal-${opener.dataset.modalOpen}`);
    if (!modal) return;
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(modal);
    });
  });

  modals.forEach((modal) => {
    modal.querySelectorAll('[data-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => closeModal(modal));
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    modals.forEach((modal) => {
      if (!modal.hidden) closeModal(modal);
    });
  });

  modals.forEach((modal) => {
    if (!modal.dataset.autoopen) return;

    const storageKey = `ht-popup-seen:${modal.id}`;
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch {
      // sessionStorage indisponível (ex.: navegação privada) — abre normalmente.
    }

    setTimeout(() => {
      openModal(modal);
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch {
        // ignora — pior caso, o popup pode reaparecer na próxima página.
      }
    }, Number(modal.dataset.autoopen));
  });
};
